/* DogTheme — vanilla JS interactivity
   Handles: countdown timer, accordions (FAQ + myths), tabs (mech/stacks),
            gallery carousel, plan toggle, variant select, sticky cart visibility,
            scrolling marquee duplication, sticky cart variant sync.
*/
(function () {
  'use strict';

  // ---------- helpers ----------
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from((c || document).querySelectorAll(s));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts || false);

  // ---------- countdown (announcement bar) ----------
  function initCountdown() {
    $$('[data-countdown]').forEach(el => {
      // hours,minutes,seconds attrs (defaults: 23h 2m 37s)
      let h = parseInt(el.dataset.hours || '23', 10);
      let m = parseInt(el.dataset.minutes || '2', 10);
      let s = parseInt(el.dataset.seconds || '37', 10);
      const hEl = el.querySelector('[data-cd-h]');
      const mEl = el.querySelector('[data-cd-m]');
      const sEl = el.querySelector('[data-cd-s]');
      const pad = n => String(n).padStart(2, '0');
      const render = () => {
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      };
      render();
      setInterval(() => {
        if (s > 0) { s--; }
        else if (m > 0) { m--; s = 59; }
        else if (h > 0) { h--; m = 59; s = 59; }
        render();
      }, 1000);
    });
  }

  // ---------- ship time countdown (minutes only) ----------
  function initShipCountdown() {
    $$('[data-shiptime]').forEach(el => {
      let h = parseInt(el.dataset.hours || '4', 10);
      let m = parseInt(el.dataset.minutes || '22', 10);
      const hEl = el.querySelector('[data-st-h]');
      const mEl = el.querySelector('[data-st-m]');
      const render = () => {
        if (hEl) hEl.textContent = h;
        if (mEl) mEl.textContent = m;
      };
      render();
      setInterval(() => {
        if (m > 0) { m--; }
        else if (h > 0) { h--; m = 59; }
        render();
      }, 60000);
    });
  }

  // ---------- accordions (FAQ + myths) ----------
  function initAccordions() {
    $$('[data-accordion]').forEach(group => {
      const allowMultiple = group.dataset.accordion === 'multiple';
      const items = $$('[data-accordion-item]', group);
      items.forEach(item => {
        const btn = $('[data-accordion-btn]', item);
        if (!btn) return;
        on(btn, 'click', () => {
          const wasOpen = item.classList.contains('is-open');
          if (!allowMultiple) {
            items.forEach(i => i.classList.remove('is-open'));
          }
          if (!wasOpen) item.classList.add('is-open');
          else item.classList.remove('is-open');
        });
      });
    });
  }

  // ---------- tabs (mech + stacks) ----------
  function initTabs() {
    $$('[data-tabs]').forEach(tabs => {
      const btns = $$('[data-tab-btn]', tabs);
      const panels = $$('[data-tab-panel]', tabs);
      btns.forEach(btn => {
        on(btn, 'click', () => {
          const target = btn.dataset.tabBtn;
          btns.forEach(b => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
          panels.forEach(p => p.classList.toggle('is-active', p.dataset.tabPanel === target));
        });
      });
    });
  }

  // ---------- gallery carousel ----------
  function initGalleries() {
    $$('[data-gallery]').forEach(gal => {
      const slides = $$('[data-gallery-slide]', gal);
      const dots = $$('[data-gallery-dot]', gal);
      const thumbs = $$('[data-gallery-thumb]', gal);
      const prev = $('[data-gallery-prev]', gal);
      const next = $('[data-gallery-next]', gal);
      let i = 0;
      const go = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
        thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));
      };
      dots.forEach((d, idx) => on(d, 'click', () => go(idx)));
      thumbs.forEach((t, idx) => on(t, 'click', () => go(idx)));
      on(prev, 'click', () => go(i - 1));
      on(next, 'click', () => go(i + 1));
      // touch swipe
      let startX = null;
      on(gal, 'touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      on(gal, 'touchend', e => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        startX = null;
      });
    });
  }

  // ---------- sticky bar price (follows bundle + plan) ----------
  function updateStickyPrice(root) {
    const panel = root.closest ? (root.closest('[data-buypanel]') || root) : root;
    const activeCard = panel.querySelector && panel.querySelector('[data-variant-card].is-active');
    if (!activeCard) return;
    const planMode = panel.dataset ? (panel.dataset.plan || 'sub') : 'sub';
    const price = planMode === 'sub'
      ? (activeCard.dataset.subPrice || activeCard.dataset.price)
      : (activeCard.dataset.oncePrice || activeCard.dataset.price);
    if (!price) return;
    $$('[data-sticky-cart] [data-sticky-price]').forEach(p => { p.textContent = price; });
  }

  // ---------- plan toggle (subscription/one-time) ----------
  function initPlanToggle() {
    $$('[data-plan-toggle]').forEach(toggle => {
      const btns = $$('[data-plan-btn]', toggle);
      const root = toggle.closest('[data-buypanel]') || document;
      const form = toggle.closest('form');
      const sellingPlanInput = form && form.querySelector('[data-selling-plan-input]');

      const applyPlan = (plan, btn) => {
        btns.forEach(b => b.classList.toggle('is-active', b === btn));
        root.dataset.plan = plan;
        // check the radio inside the active card
        const radio = btn.querySelector('input[type=radio][name=plan]');
        if (radio) radio.checked = true;
        // Pull selling_plan from the active bundle (variant card), not from a fixed value
        if (sellingPlanInput) {
          const activeCard = root.querySelector('[data-variant-card].is-active');
          const cardPlanId = activeCard ? (activeCard.dataset.sellingPlanId || '') : '';
          sellingPlanInput.value = (plan === 'sub') ? cardPlanId : '';
        }
        updateStickyPrice(root);
      };

      btns.forEach(btn => {
        on(btn, 'click', () => applyPlan(btn.dataset.planBtn, btn));
      });

      // init from the card already marked is-active
      const initialActive = btns.find(b => b.classList.contains('is-active')) || btns[0];
      if (initialActive) applyPlan(initialActive.dataset.planBtn, initialActive);
    });
  }

  // ---------- variant select ----------
  function initVariants() {
    $$('[data-buypanel]').forEach(panel => {
      const cards = $$('[data-variant-card]', panel);
      const cta = $('[data-buynow]', panel);
      const form = $('form[data-funnel-form]', panel);
      const sellingPlanInput = form && form.querySelector('[data-selling-plan-input]');
      const subName = $('[data-sub-name]', panel);
      const subPrice = $('[data-sub-price]', panel);
      const subCompare = $('[data-sub-compare]', panel);
      const oncePrice = $('[data-once-price]', panel);

      const syncSelection = (card) => {
        cards.forEach(c => c.classList.toggle('is-active', c === card));
        // check the radio inside this card if present
        const radio = card.querySelector('input[type=radio][name=id]');
        if (radio) radio.checked = true;
        const variantId = card.dataset.variantId;
        if (cta && variantId) cta.dataset.variantId = variantId;
        updateStickyPrice(panel);

        // Update Subscribe + One-Time displays from this bundle's data
        const cardSubPrice = card.dataset.subPrice;
        const cardSubCompare = card.dataset.subCompare;
        const cardOncePrice = card.dataset.oncePrice;
        const cardPlanName = card.dataset.sellingPlanName;
        if (subPrice && cardSubPrice) subPrice.textContent = cardSubPrice;
        if (subCompare && cardSubCompare) subCompare.textContent = cardSubCompare;
        if (oncePrice && cardOncePrice) oncePrice.textContent = cardOncePrice;
        if (subName && cardPlanName) subName.textContent = cardPlanName;

        // Update form's selling_plan input based on current plan mode + this card's plan
        if (sellingPlanInput) {
          const planMode = panel.dataset.plan || 'sub';
          const cardPlanId = card.dataset.sellingPlanId || '';
          sellingPlanInput.value = (planMode === 'sub') ? cardPlanId : '';
        }
      };
      const initialActive = cards.find(c => c.classList.contains('is-active')) || cards[0];
      if (initialActive) syncSelection(initialActive);
      cards.forEach(card => on(card, 'click', () => syncSelection(card)));

      // Safety: on form submit, re-sync from the currently active card and strip
      // selling_plan if it doesn't match the active bundle (prevents Shopify's
      // "Cannot apply selling plan to variant" error).
      if (form) {
        on(form, 'submit', () => {
          const activeCard = cards.find(c => c.classList.contains('is-active'));
          if (!activeCard || !sellingPlanInput) return;
          const planMode = panel.dataset.plan || 'sub';
          const cardPlanId = activeCard.dataset.sellingPlanId || '';
          sellingPlanInput.value = (planMode === 'sub' && cardPlanId) ? cardPlanId : '';
        });
      }
    });
  }

  // ---------- sticky add-to-cart visibility ----------
  function initStickyCart() {
    const bar = $('[data-sticky-cart]');
    if (!bar) return;
    const threshold = parseInt(bar.dataset.threshold || '600', 10);
    let raf = null;
    const update = () => {
      bar.classList.toggle('is-visible', window.scrollY > threshold);
      raf = null;
    };
    on(window, 'scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }

  // ---------- marquee duplication (so animation loops seamlessly) ----------
  function initMarquees() {
    $$('[data-marquee]').forEach(track => {
      if (track.dataset.marqueeInit) return;
      track.dataset.marqueeInit = '1';
      const html = track.innerHTML;
      track.innerHTML = html + html;
    });
  }

  // ---------- scroll-snap carousels (reviews, badges, etc.) ----------
  function initScrollCarousels() {
    $$('[data-scroll-carousel]').forEach(root => {
      const track = $('[data-scroll-track]', root);
      const prev = $('[data-scroll-prev]', root);
      const next = $('[data-scroll-next]', root);
      const dotsWrap = $('[data-scroll-dots]', root);
      if (!track) return;

      const items = Array.from(track.children).filter(el => !el.hasAttribute('data-scroll-ignore'));

      // Build dots (one per item)
      let dots = [];
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        items.forEach((_, i) => {
          const b = document.createElement('button');
          b.className = 'scroll-dot' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', () => {
            scrollToIndex(i);
          });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      const scrollToIndex = (i) => {
        const item = items[i];
        if (!item) return;
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };

      const currentIndex = () => {
        const scrollLeft = track.scrollLeft;
        let best = 0;
        let bestDelta = Infinity;
        items.forEach((it, i) => {
          const delta = Math.abs(it.offsetLeft - track.offsetLeft - scrollLeft);
          if (delta < bestDelta) { bestDelta = delta; best = i; }
        });
        return best;
      };

      const updateDots = () => {
        const i = currentIndex();
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      };

      on(prev, 'click', () => {
        const i = Math.max(0, currentIndex() - 1);
        scrollToIndex(i);
      });
      on(next, 'click', () => {
        const i = Math.min(items.length - 1, currentIndex() + 1);
        scrollToIndex(i);
      });

      let ticking = false;
      on(track, 'scroll', () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(() => { updateDots(); ticking = false; });
        }
      }, { passive: true });
    });
  }

  // ---------- add-to-cart (Shopify cart API) ----------
  function initBuyNow() {
    $$('[data-buynow]').forEach(btn => {
      on(btn, 'click', async (e) => {
        const id = btn.dataset.variantId;
        if (!id) return;
        e.preventDefault();
        const qty = parseInt(btn.dataset.qty || '1', 10);
        btn.setAttribute('disabled', 'true');
        const original = btn.textContent;
        btn.textContent = 'Adding…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
          });
          if (!res.ok) throw new Error('add failed');
          if (btn.dataset.redirect === 'checkout') window.location.href = '/checkout';
          else window.location.href = '/cart';
        } catch (err) {
          btn.removeAttribute('disabled');
          btn.textContent = original;
          alert('Sorry, we could not add this to your cart. Please try again.');
        }
      });
    });
  }

  // ---------- newsletter form (front-end only validation) ----------
  function initNewsletter() {
    $$('input[data-newsletter]').forEach(input => {
      const form = input.closest('form');
      if (!form) return;
      on(form, 'submit', (e) => {
        if (!input.value.includes('@')) {
          e.preventDefault();
          input.focus();
        }
      });
    });
  }

  // ---------- init all ----------
  function init() {
    initCountdown();
    initShipCountdown();
    initAccordions();
    initTabs();
    initGalleries();
    initPlanToggle();
    initVariants();
    initStickyCart();
    initMarquees();
    initScrollCarousels();
    initBuyNow();
    initNewsletter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();